import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Checkbox, Typography, Box,
} from '@mui/material';

const EditWorkAreaDialog = ({ open, onClose, projectRooms, selectedRoomIds, onRoomIdsChange, onSubmit }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Edit Work Area</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select rooms to include in this work area
      </Typography>
      <Box sx={{ mt: 2 }}>
        {projectRooms
          .filter(r => r.type !== 'work_area')
          .map((room) => (
            <Box key={room.id} sx={{ mb: 1 }}>
              <Checkbox
                checked={selectedRoomIds.includes(room.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    onRoomIdsChange([...selectedRoomIds, room.id]);
                  } else {
                    onRoomIdsChange(selectedRoomIds.filter(id => id !== room.id));
                  }
                }}
              />
              <Typography component="span" variant="body1">
                {room.name}
              </Typography>
            </Box>
          ))}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSubmit} variant="contained" color="primary">
        Save Changes
      </Button>
    </DialogActions>
  </Dialog>
);

export default EditWorkAreaDialog;
